<template>
    <div v-if="usersTable.data.length>0" class="container">


        <GmapMap :center="{lat:56.3, lng:10.1}" :zoom="6" map-type-id="hybrid" :style="'height:'+mapheight+'px;'" @click="maptoggle()">
            <gmap-custom-marker v-for="(customer, index) in customersPlaces"
                :key="index"
                :marker="{lat: customer.lat, lng: customer.lng}"
                :clickable="true" :draggable="false">
                <img v-if="differentDays(customer.creation_date)>30" src="https://maps.google.com/mapfiles/ms/icons/red-dot.png"/>
                <img v-else src="https://maps.google.com/mapfiles/ms/icons/orange-dot.png"/>
            </gmap-custom-marker>
        </GmapMap>


        <vue-table-dynamic class="tableModifier" :params="usersTable" @row-click="onSelect" ref="table">
        </vue-table-dynamic>
    </div>
    <Loading v-else/>
</template>
<style lang="scss">
.vue-map-container{
    width: 100%;
    margin-bottom: 3rem;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    background-color: var(--bg-color-2);
    .gmnoprint, [style="margin-left: 5px; margin-right: 5px; z-index: 1000000; position: absolute; left: 0px; bottom: 0px;"], .gm-control-active.gm-fullscreen-control{
        display: none;
    }
    *{
        font-family: inherit !important;
    }
    position: relative;
    &:after{
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color:black;
        transition: opacity 300ms ease;
        opacity: 0;
        pointer-events: none;
    }
    @media (prefers-color-scheme: dark){
        &:after{
            opacity: 0.2;
        }
    }
}
</style>
<script>
import VueTableDynamic from 'vue-table-dynamic';
import Loading from '@/components/parts/Loading.vue';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
export default {
    name: 'Customers',
    components: { VueTableDynamic, Loading,'gmap-custom-marker': GmapCustomMarker },
    data() {
        return {
            mapheight: 400,
            customers: [],
            usersTable: {
                data: this.$store.state.usersTable,
                header: 'row',
                enableSearch: true,
                pagination: true,
                pageSize: 25,
                pageSizes: [],
                sort: [0],
                maxWidth:2000,
            },
            tablehead: [['ID','Name','Email','Phone','Address','Created at','Country']],
        }
    },
    sockets: {
        allusers(data) {
            this.raw_users = data;
        },
    },
    computed: {
        customersPlaces(){
            return this.customers.filter(data => { return data.lng != null && data.lng != 0;});
        }
    },
    methods: {
        maptoggle(){
            if(this.mapheight==400){
                this.mapheight=1000
            }else{
                this.mapheight=400
            }
        },
        onSelect (index, data) {
            if(data[0]!='ID'){
                this.$router.push('/customers/'+data[0]);
            }
        },
        differentDays: function(date){
            var date1 = new Date(date); 
            var date2 = new Date();
            var Difference_In_Time = date2.getTime() - date1.getTime(); 
            return (Difference_In_Time / (1000 * 3600 * 24));
        },
        getUsers: function(){
            var vue = this;
            this.$socket.client.emit('getUsers',null, (error, response) => {
                if(error=='200'){
                    vue.customers = response;
                    vue.usersTable.data = vue.tablehead.concat(response.map(data => [data.id,data.name,data.email,data.phone,data.address,data.creation_date,data.country]));
                    vue.$store.state.usersTable = vue.tablehead.concat(response.map(data => [data.id,data.name,data.email,data.phone,data.address,data.creation_date,data.country]));
                }
            })
        }
    },
    mounted() {
        this.getUsers();
    },
}
</script>